var render, staticRenderFns
import script from "./CListItem.vue?vue&type=script&lang=ts"
export * from "./CListItem.vue?vue&type=script&lang=ts"
import style0 from "./CListItem.vue?vue&type=style&index=0&id=71b8dafc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports